import React from 'react';

import LoginForm from 'components/login/LoginForm';

const Login = ({ history }) => <LoginForm history={history}></LoginForm>;

export default Login;
